import { render } from "./HomeScreensList.vue?vue&type=template&id=55959f76&scoped=true&ts=true"
import script from "./HomeScreensList.vue?vue&type=script&lang=ts"
export * from "./HomeScreensList.vue?vue&type=script&lang=ts"

import "./HomeScreensList.vue?vue&type=style&index=0&id=55959f76&lang=css"
import "./HomeScreensList.vue?vue&type=style&index=1&id=55959f76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55959f76"]])

export default __exports__